<template>
  <div rounded
    class="d-flex rounded align-center"
    style="background-color: #E1E1E1; border: 1px solid #CEE7CF;"
  >
    <div 
      class="flex-grow-1 grey--text text--darken-1 ma-2 py-2 px-3 rounded-lg text-center"
      style="background-color: white; font-size: 14px;"
    >
      <div style="line-height: 1.25;">Needed for<br>next reward</div>
      <div class="black--text font-weight-bold mt-1" style="font-size: 20px;">{{ $formatters.formatCurrency(remaining) }}</div>
    </div>

    <div class="d-flex flex-column align-center pa-2">
      <RewardProgress :completed="completedPct">
        <div class="d-flex flex-column align-center">
          <div class="grey--text text--darken-1">Rewards</div>
          <div class="font-weight-bold mt-n2" style="font-size: 24px">{{ $formatters.formatCurrency(me.reward_balance_cents) }}</div>
        </div>
      </RewardProgress>

      <div class="grey--text text--darken-1 mt-n3" style="font-size: 14px">
        {{ $formatters.formatCurrency(redeemableCents) }}
      </div>
    </div>  

    <div
      class="flex-grow-1 white--text text--darken-1 ma-2 py-2 px-2 rounded-lg elevation-2 text-center font-weight-bold d-flex align-center justify-center"
      style="min-width: 85px; height: 85px; background-color: #3EB83D;"
      @click="$router.push({ name: 'redeem'})"
    >
      <div style="font-size: 14px; line-height: 1.25;">
        REDEEM<br>NOW
      </div>
    </div>
  </div>
</template>

<script>
import RewardProgress from './RewardProgress'
import { mapGetters } from 'vuex'

export default {
  name: 'RewardsBalanceSummary',

  components: { RewardProgress },

  data: () => ({
    increment: 25_00,
  }),

  computed: {
    ...mapGetters('auth', ['me']),

    rewardCents() { return this.me.reward_balance_cents },

    nextRewardCents() {
      let rewards = Math.ceil(this.rewardCents / this.increment)

      return (rewards + 1) * this.increment
    },

    remaining() {
      const nextReward = Math.ceil(this.rewardCents / this.increment) * this.increment
      const remainingCents = nextReward - this.rewardCents

      return remainingCents == 0 ? this.increment : remainingCents
    },

    completedPct() { return this.rewardCents * 1.0 / this.nextRewardCents },
    redeemable() { 
      return this.rewardsCents >= this.increment
    },
    redeemableCents() { return Math.floor(this.rewardCents / this.increment) * this.increment },
  },

  methods: {
  },
}


</script>
